import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { DefaultTriggerElement as DefaultTriggerElementModel } from '../../../../models/ConversationHistory/HistoryElement/TriggerHistoryElement/DefaultTriggerElement';
import rootStore from '../../../../stores/rootStore';
import { useGetIcon } from '../../../customHooks/useGetIcon';
import BaseHistoryElement from '../BaseHistoryElement';

interface IProps {
  element: DefaultTriggerElementModel;
}

const DefaultTriggerElement: React.FC<IProps> = ({ element }: IProps) => {
  const getIcon = useGetIcon();
  const { blockStore } = useContext(rootStore);
  const block = blockStore?.allBlocks?.find(
    (block) => block?.trigger?.id === element.triggerId
  );

  return (
    <BaseHistoryElement
      element={element}
      title='Default Trigger evaluated'
      icon={getIcon('default_trigger')}
    >
      {element.triggered ? (
        <div className='card-paragraph'>
          <i className={getIcon('check')}> </i>
          <span> Triggered block {block?.title && '{block?.title}'}</span>
        </div>
      ) : (
        <div className='card-paragraph'>
          <i className={getIcon('error')}> </i>
          <span> Not triggered block {block?.title && '{block?.title}'} </span>
        </div>
      )}
    </BaseHistoryElement>
  );
};

export default observer(DefaultTriggerElement);
